import React, { Component } from "react";
import { connect } from "react-redux";
import { BreadCumb, DataTables, NavBar, TimeOut } from "../../components";
import config from "../../config";
import moment from 'moment';
import ApiClient from "../../libs/apiClient";
import { DISPATCH_ID } from "../../libs/utils/Const";
const TODAY = moment(new Date()).format('YYYY-MM-DD');
const apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "ID Empleado", value: true },
    { title: "Nombre", value: true },
    { title: "RFC", value: true },
    { title: "CURP", value: true },
    { title: "Inicio Laboral", value: true }
]

class EmployeeNomina extends Component {
    constructor(props) {
        super(props)
        this.state = {
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),

        }
    }

    async componentDidMount() {
        this.SearchDocuments()
    }

    SearchDocuments = async (newDate) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        const data = {
            dateInit: newDate?.dateInit ?? TODAY,
            dateFinal: newDate?.dateFinal ?? TODAY,
            keySearch: newDate?.docNumSearch ?? '--',
        };

        enableSpinner(true);
        const resData = await apiClient.GetListEmployeeNom(data);
        enableSpinner(false);
        
        if (resData.status !== 1) {
            showAlert({ type: 'warning', timeOut: 5000, message: `${resData.message ?? ''}` });
        }

        if (resData.data.length === 0) {
            showAlert({ type: 'info', timeOut: 5000, message: `No se encontró información` });
        }

        this.setState({
            data: resData.data ?? []
        })
    }

    render() {
        const { headers, data, _user } = this.state;

        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <BreadCumb subitem1={'EMPLEADOS NOMINAS'} url1={'#'} />
                <TimeOut />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <label className="text-muted">
                            EMPLEADOS
                        </label>
                    </h2>
                    <DataTables
                        headers={headers}
                        view={"employeeNomina"}
                        data={data}
                        search={this.SearchDocuments}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EmployeeNomina);